import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Form,
    InputGroup,

} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from 'react-notification-system';
import { style } from "../../../variables/Variables";
import Select from "react-select";
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { getDelivery_type, updateDelivery_type, getCity } from "../../../Listfunction";


class editDeliveryType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            delivery_type_label: '',
            delivery_type_labelError: null,
            delivery_type_value: '',
            delivery_type_valueError: null,
            delivery_type_charge: '',
            delivery_type_chargeError: null,
            delivery_type_within: '',
            delivery_type_withinError: null,
            delivery_type_id: '',
            delivery_type_idError: null,
            district_info: [],
            district: '0',
            processing: true,
            cardHidden: true,
            order_type: '',
            order_type_error : null,
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);

    }

    onEditorStateChange = (editorState) => {
        this.setState({ delivery_type_value: editorState });
    }

    async componentDidMount() {

        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;

        var id = JSON.parse(localStorage.getItem("DeliveryTypeID"));


        await getDelivery_type(id, obj).then((response) => {
            var data = response.data.data

            const contentBlock = htmlToDraft(data.delivery_type_value);

            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);


            var ordertyp = ''
            console.log(data.order_type)
           if (data.order_type == 1) {
                ordertyp = {value: "Medicine",label:"Medicine"}
        
            }
            else if (data.order_type == 2) {
                ordertyp = {value: "Lab Order",label:"Lab Order"}       
            }
            else if (data.order_type == 3) {
                ordertyp = {value: "Raya",label:"Raya"}
            }
            console.log(ordertyp)

            this.setState({
                
                delivery_type_label: data.delivery_type_label,
                delivery_type_value: editorState,
                delivery_type_charge: data.delivery_charges,
                delivery_type_within: data.delivery_within,
                delivery_type_id: data.delivery_type_id,
                district: data.city_id,
                order_type: ordertyp


            })

        })

        var country_id = 1
        await getCity(obj, country_id).then((res) => {
            this.setState({ district_info: res.data });
        });


        this.setState({ _notificationSystem: this.refs.notificationSystem })
        setTimeout(
            function () {
                this.setState({ cardHidden: false });
            }.bind(this),
            700
        );

    }

    onChange = (e, i) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

    }

    onSubmit = () => {
        let error = false;
        let regx = /^-?[0-9]*$/
        let chargeregx = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/

        if (this.state.order_type == null) {
            error = true
            this.setState({
                order_type_error: (
                    <small className="text-danger">
                        Order Type is required.
                    </small>
                )
            })
        } else { this.setState({ order_type_error: null }); }

        if (this.state.delivery_type_id.length == 0) {
            error = true
            this.setState({
                delivery_type_idError: (
                    <small className="text-danger">
                        Delivery Id is required.
                    </small>
                )
            })
        } else if (regx.test(this.state.delivery_type_id) === false) {
            error = true
            this.setState({
                delivery_type_idError: (
                    <small className="text-danger">
                        Delivery Id should be numeric value.
                    </small>
                )
            })
        } else { this.setState({ delivery_type_idError: null }); }

        if (this.state.district == '0') {
            var isdistrict = ''
        }
        else {
            var isdistrict = this.state.district
        }

        if (this.state.delivery_type_label.length == 0) {
            error = true
            this.setState({
                delivery_type_labelError: (
                    <small className="text-danger">
                        Delivery Type is required.
                    </small>
                )
            })
        } else { this.setState({ delivery_type_labelError: null }); }

        if (this.state.delivery_type_value.length == 0) {
            error = true
            this.setState({
                delivery_type_valueError: (
                    <small className="text-danger">
                        Delivery Type value is required.
                    </small>
                )
            })
        } else { this.setState({ delivery_type_valueError: null }); }

        if (this.state.delivery_type_charge.length == 0) {
            error = true
            this.setState({
                delivery_type_chargeError: (
                    <small className="text-danger">
                        Delivery charge is required.
                    </small>
                )
            })
        } else if (chargeregx.test(this.state.delivery_type_charge) === false) {
            error = true
            this.setState({
                delivery_type_chargeError: (
                    <small className="text-danger">
                        Delivery charge should be numeric value.
                    </small>
                )
            })
        } else { this.setState({ delivery_type_chargeError: null }); }

        if (this.state.delivery_type_within.length == 0) {
            error = true
            this.setState({
                delivery_type_withinError: (
                    <small className="text-danger">
                        Delivery within is required.
                    </small>
                )
            })
        } else { this.setState({ delivery_type_withinError: null }); }

        if (!error) {
            var token = JSON.parse(localStorage.getItem("user"));
            const obj = token.token;

            var id = JSON.parse(localStorage.getItem("DeliveryTypeID"));
            var delivery_type_valueInfo = draftToHtml(convertToRaw(this.state.delivery_type_value.getCurrentContent()))

            var ordertp = ''
            if (this.state.order_type.value == 'Medicine') {
                ordertp = '1'
            }
            else if (this.state.order_type.value == 'Lab order') {
                ordertp = '2'
            }
            else if (this.state.order_type.value == 'Raya') {
                ordertp = '3'
            }

            updateDelivery_type(
                this.state.delivery_type_label,
                delivery_type_valueInfo,
                this.state.delivery_type_charge,
                this.state.delivery_type_within,
                this.state.delivery_type_id,
                isdistrict,
                ordertp,
                obj,
                id,

            ).then((res) => {

                if (res.data.success === true) {
                    this.handleSuccess("bl");
                }
            }).catch((error) => {
                console.log(error, "== error");
                this.handleNetworkError("bl");
            });
        }
    }

    handleSuccess(position) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "success";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
                <div>
                    <b>Delivery Type</b> - Updated Successfully.
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 15,
        });
        setTimeout(() => {
            this.props.history.push('/admin/deliverytype');
        }, 3000);
    }

    handleNetworkError(position) {
        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        level = "error";
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
                <div>
                    <b>Network Error</b>.
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 15,
        });
    }

    render() {
        return (
            <div className="main-content">
                <Grid fluid>
                    <NotificationSystem ref="notificationSystem" style={style} />
                    <Row>
                        <Col md={6}>
                            <Card
                                content={
                                    <form >
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <ControlLabel>Delivery Id</ControlLabel>
                                                    <FormControl name="delivery_type_id" value={this.state.delivery_type_id} onChange={event => {
                                                        this.setState({ delivery_type_id: event.target.value });
                                                        event.target.value === ""
                                                            ? this.setState({
                                                                delivery_type_idError: (
                                                                    <small className="text-danger">
                                                                        Delivery Id is required.
                                                                    </small>
                                                                )
                                                            })
                                                            : this.setState({ delivery_type_idError: null });
                                                    }} placeholder="Enter label" type="text" />
                                                    {this.state.delivery_type_idError}
                                                </FormGroup>
                                                <FormGroup>
                                                    <ControlLabel>Delivery Type Label</ControlLabel>
                                                    <FormControl name="delivery_type_label" value={this.state.delivery_type_label} onChange={event => {
                                                        this.setState({ delivery_type_label: event.target.value });
                                                        event.target.value === ""
                                                            ? this.setState({
                                                                delivery_type_labelError: (
                                                                    <small className="text-danger">
                                                                        Delivery Type label is required.
                                                                    </small>
                                                                )
                                                            })
                                                            : this.setState({ delivery_type_labelError: null });
                                                    }} placeholder="Enter label" type="text" />
                                                    {this.state.delivery_type_labelError}
                                                </FormGroup>

                                                {/* <FormGroup>
                                                    <ControlLabel>Delivery Type Value</ControlLabel>
                                                    <FormControl name="delivery_type_value" value={this.state.delivery_type_value} onChange={event => {
                                                        this.setState({ delivery_type_value: event.target.value });
                                                        event.target.value === ""
                                                            ? this.setState({
                                                                delivery_type_valueError: (
                                                                    <small className="text-danger">
                                                                        Delivery Type Value is required.
                                                                    </small>
                                                                )
                                                            })
                                                            : this.setState({ delivery_type_valueError: null });
                                                    }} placeholder="Enter value" type="text" />
                                                    {this.state.delivery_type_valueError}
                                                </FormGroup> */}

                                                <FormGroup>
                                                    <ControlLabel>Delivery Type Value</ControlLabel>
                                                    <Editor
                                                        editorState={this.state.delivery_type_value}
                                                        editorClassName="terms-editor"
                                                        onEditorStateChange={this.onEditorStateChange}
                                                    />
                                                    {this.state.delivery_type_valueError}
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Delivery Within</ControlLabel>
                                                    <FormControl name="delivery_type_within" value={this.state.delivery_type_within} onChange={event => {
                                                        this.setState({ delivery_type_within: event.target.value });
                                                        event.target.value === ""
                                                            ? this.setState({
                                                                delivery_type_withinError: (
                                                                    <small className="text-danger">
                                                                        Delivery within is required.
                                                                    </small>
                                                                )
                                                            })
                                                            : this.setState({ delivery_type_withinError: null });
                                                    }} placeholder="Enter delivery within" type="text" />
                                                    {this.state.delivery_type_withinError}
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Delivery Charge</ControlLabel>
                                                    <FormControl name="delivery_type_charge" value={this.state.delivery_type_charge} onChange={event => {
                                                        this.setState({ delivery_type_charge: event.target.value });
                                                        event.target.value === ""
                                                            ? this.setState({
                                                                delivery_type_chargeError: (
                                                                    <small className="text-danger">
                                                                        Delivery charge is required.
                                                                    </small>
                                                                )
                                                            })
                                                            : this.setState({ delivery_type_chargeError: null });
                                                    }} placeholder="Enter delivery charge" type="text" />
                                                    {this.state.delivery_type_chargeError}
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>District</ControlLabel>
                                                    <select
                                                        className="form-control"
                                                        name="district"
                                                        value={this.state.district == null ? '' : this.state.district}
                                                        onChange={this.onChange}
                                                    >
                                                        <option value="0"> Select District</option>
                                                        {this.state.district_info.map((district) => (
                                                            <option key={district.id} value={district.id}>{district.city_name}</option>
                                                        ))}
                                                    </select>
                                                </FormGroup>

                                                <FormGroup>
                                                    <ControlLabel>Order Type</ControlLabel>
                                                    <Select
                                                        className="react-select primary"
                                                        classNamePrefix="react-select"
                                                        placeholder="Order Type"
                                                        name="order_type"
                                                        value={this.state.order_type}
                                                        onChange={(value) =>
                                                            this.setState({
                                                                order_type: value,
                                                            })
                                                        }
                                                        options={[
                                                            { value: "Medicine", label: "Medicine" },
                                                            { value: "Lab order", label: "Lab order" },
                                                            { value: "Raya", label: "Raya" },
                                                        ]}
                                                    />
                                                    {this.state.order_type_error}
                                                </FormGroup>

                                            </Col>
                                        </Row>
                                        <Button disabled={!this.state.processing} onClick={this.onSubmit.bind(this)} className="btn-color" //bsStyle="info" 
                                            fill>
                                            Submit
                                        </Button>
                                    </form>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default editDeliveryType;